import { useCallback } from 'react';
import { clusterCountLayerId, clusterLayerId, unclusteredLayerId } from "../components/Map/helpers";

export const useMarkerVisibility = (
  map,
  poiIdRef,
  poiMarkers,
) => {
  return useCallback((onlyVisiblePois = false) => {
    if (!map) return;

    const activeId = poiIdRef.current;

    const clusterVis = !!activeId ? 'none' : 'visible';
    [clusterLayerId, clusterCountLayerId, unclusteredLayerId].forEach(layerId => {
      if (map.getLayer(layerId)) {
        map.setLayoutProperty(layerId, 'visibility', clusterVis);
      }
    });

    if (activeId) {
      Object.entries(poiMarkers.current).forEach(([id, marker]) => {
        const el = marker.getElement();
        const isTarget = id === String(activeId);
        el.style.display = isTarget ? '' : 'none';

        // toggle popup
        const popup = marker.getPopup?.();
        if (popup && map) {
          if (isTarget) {
            if (!popup.isOpen()) {
              popup.addTo(map);
            }
          } else {
            popup.remove();
          }
        }
      });

      [clusterLayerId, clusterCountLayerId, unclusteredLayerId].forEach(layer => {
        if (map?.getLayer(layer)) {
          map.setLayoutProperty(layer, 'visibility', 'none');
        }
      });
    } else {
      [clusterLayerId, clusterCountLayerId].forEach(layer => {
        if (map?.getLayer(layer)) {
          map.setLayoutProperty(layer, 'visibility', 'visible');
        }
      });
      const bounds = map.getBounds();
      const features = map.getLayer(unclusteredLayerId)
        ? map.queryRenderedFeatures(undefined, { layers: [unclusteredLayerId] })
        : [];
      const visibleIds = new Set(features.map(f => f.properties.id));

      Object.entries(poiMarkers.current).forEach(([id, marker]) => {

        const { lng, lat } = marker.getLngLat();
        const inBounds =
          lng >= bounds.getWest() && lng <= bounds.getEast() &&
          lat >= bounds.getSouth() && lat <= bounds.getNorth();

        const isVisible = visibleIds.has(Number(id)) && inBounds;

        if (onlyVisiblePois && isVisible) {
          marker.getElement().style.display = '';
        } else {
          marker.getElement().style.display = isVisible ? '' : 'none';
        }
      });
    }
  }, [map, poiIdRef, poiMarkers]);
};